'use client';

import { useMemo } from 'react';
import { TabsFilterValue } from '../../types/project/tabs';
import { AnnouncementList } from '../announcement/AnnouncementList';
import { CardDetail } from '../CardDetail';
import { ProjectOngoingInteractionList } from '../project/ProjectOngoingInteractionList';
import { useProjectTabsContext } from '../provider/ProjectTabsProvider';
import { ProjectSteps } from '../steps/ProjectSteps';

export function InteractionList() {
  const { activeInteraction, activeTabFilter } = useProjectTabsContext();

  const [isNews, isOngoing, isSteps] = useMemo(() => ([
    activeTabFilter === TabsFilterValue.NEWS,
    activeTabFilter === TabsFilterValue.ONGOING,
    activeTabFilter === TabsFilterValue.STEPS,
  ]), [activeTabFilter]);

  return (
    <>
      {!!activeInteraction && (
        <CardDetail />
      )}
      {isOngoing && !activeInteraction && (
        <ProjectOngoingInteractionList />
      )}
      {isSteps && !activeInteraction && (
        <ProjectSteps />
      )}
      {isNews && !activeInteraction && (
        <AnnouncementList />
      )}
    </>
  );
};
